module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAvElEQVRIS2NkIBL8v3W0E6z0P0MRmGZk6ANTatblRBoB1UakavpbePPoJajbdKH0ZbAP1a31iHQziT4ctZDIcGUkUh3D/9EgJTKo6B+k/28c64JmECf8jvyvBZXnhNLfITTjNbz6/jPsA6vSsCoD0/S38ObR31AXshAZDaQq+wMtkVghPqS7hcM+DomNkNGShtiQon9JQ6zLRuOQ2JAaxHGI3i79z9iPXAtQ34f0tpBYHxBSR3QcEjKIWHkADkiYHf+2pagAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/ancientBooks/more_icon@2x.png
// module id = hLcD
// module chunks = 1